<ng-container *ngIf="!isPublicRoute; else publicRoute">
  <div class="app-shell" [class.sidebar-collapsed]="sidebarCollapsed">
    <div class="sidebar-backdrop" [class.open]="sidebarOpen" (click)="sidebarOpen = false"></div>
    <aside class="sidebar" [class.open]="sidebarOpen" [class.collapsed]="sidebarCollapsed">
      <div class="sidebar-brand">
        <img [src]="themeService.theme() === 'light' ? '/assets/images/logo-light.png' : '/assets/images/logo-dark.png'" alt="AdaptivAI" class="sidebar-logo" />
        <div class="sidebar-brand-text">
          <span class="sidebar-brand-name">Agentic</span>
          <span class="sidebar-brand-product">Commerce Lab</span>
        </div>
      </div>

      <div class="sidebar-spacer"></div>

      <div class="sidebar-scroll">
        <div class="sidebar-section">
          <span class="sidebar-section-label">Overview</span>
          <nav class="nav-stack">
            <a *ngFor="let item of navOverview" [routerLink]="item.path" routerLinkActive="active" class="nav-link" [title]="sidebarCollapsed ? item.label : ''">
              <lucide-icon [img]="item.icon" size="16"></lucide-icon>
              <span class="nav-label">{{ item.label }}</span>
            </a>
          </nav>
        </div>

        <div class="sidebar-section">
          <span class="sidebar-section-label">Simulation</span>
          <nav class="nav-stack">
            <a *ngFor="let item of navSimulation" [routerLink]="item.path" routerLinkActive="active" class="nav-link" [title]="sidebarCollapsed ? item.label : ''">
              <lucide-icon [img]="item.icon" size="16"></lucide-icon>
              <span class="nav-label">{{ item.label }}</span>
            </a>
          </nav>
        </div>

        <div class="sidebar-section">
          <span class="sidebar-section-label">Insights</span>
          <nav class="nav-stack">
            <a *ngFor="let item of navInsights" [routerLink]="item.path" routerLinkActive="active" class="nav-link" [title]="sidebarCollapsed ? item.label : ''">
              <lucide-icon [img]="item.icon" size="16"></lucide-icon>
              <span class="nav-label">{{ item.label }}</span>
            </a>
          </nav>
        </div>

        <div class="sidebar-section">
          <span class="sidebar-section-label">Analysis</span>
          <nav class="nav-stack">
            <a *ngFor="let item of navAnalysis" [routerLink]="item.path" routerLinkActive="active" class="nav-link" [title]="sidebarCollapsed ? item.label : ''">
              <lucide-icon [img]="item.icon" size="16"></lucide-icon>
              <span class="nav-label">{{ item.label }}</span>
            </a>
          </nav>
        </div>

        <div class="sidebar-section">
          <span class="sidebar-section-label">Agents</span>
          <nav class="nav-stack">
            <a *ngFor="let item of navAgents" [routerLink]="item.path" routerLinkActive="active" class="nav-link" [title]="sidebarCollapsed ? item.label : ''">
              <lucide-icon [img]="item.icon" size="16"></lucide-icon>
              <span class="nav-label">{{ item.label }}</span>
            </a>
          </nav>
        </div>

        <div class="sidebar-section sidebar-section-system">
          <span class="sidebar-section-label">System</span>
          <nav class="nav-stack">
            <a *ngFor="let item of navSystem" [routerLink]="item.path" routerLinkActive="active" class="nav-link" [title]="sidebarCollapsed ? item.label : ''">
              <lucide-icon [img]="item.icon" size="16"></lucide-icon>
              <span class="nav-label">{{ item.label }}</span>
            </a>
            <button type="button" class="nav-link sidebar-collapse-toggle" (click)="toggleSidebarCollapse()" [attr.aria-label]="sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'" [title]="sidebarCollapsed ? 'Expand sidebar' : ''">
              <lucide-icon [img]="sidebarCollapsed ? icons.collapseRight : icons.collapseLeft" size="16"></lucide-icon>
              <span class="nav-label collapse-label">Collapse</span>
            </button>
          </nav>
        </div>
      </div>

      <div class="sidebar-spacer"></div>

      <div class="sidebar-footer">
        <div class="sidebar-user">
          <div class="sidebar-user-avatar">
            {{ userInitials }}
            <span *ngIf="isPro" class="sidebar-user-pro-badge" title="Pro">Pro</span>
          </div>
          <div class="sidebar-user-info">
            <span class="sidebar-user-name">{{ userName || 'User' }}</span>
            <span class="sidebar-user-role">Lab member</span>
          </div>
          <button type="button" class="sidebar-logout" (click)="logout()" aria-label="Sign out">
            <lucide-icon [img]="icons.logout" size="14"></lucide-icon>
          </button>
        </div>
      </div>
    </aside>

    <div class="main-shell">
      <header class="topbar">
        <div class="topbar-left">
          <button type="button" class="sidebar-toggle" (click)="toggleSidebar()" aria-label="Toggle navigation">
            <lucide-icon [img]="sidebarOpen ? icons.close : icons.menu" size="20"></lucide-icon>
          </button>
          <div class="topbar-context" *ngIf="organizationName">
            <a routerLink="/dashboard" class="topbar-workspace" title="Go to dashboard">Workspace</a>
            <lucide-icon [img]="icons.breadcrumbSeparator" size="14" class="topbar-separator"></lucide-icon>
            <span class="topbar-welcome" *ngIf="!workspace.brands().length">Welcome</span>
            <div class="brand-picker" *ngIf="workspace.brands().length">
              <button
                type="button"
                class="brand-picker-trigger"
                (click)="brandDropdownOpen = !brandDropdownOpen"
              >
                <span>{{ workspace.activeBrand()?.name ?? 'Welcome' }}</span>
                <lucide-icon [img]="icons.brandChevron" size="14" class="brand-picker-chevron" [class.open]="brandDropdownOpen"></lucide-icon>
              </button>
              <ul class="brand-picker-menu" *ngIf="brandDropdownOpen">
                <li
                  *ngFor="let brand of workspace.brands()"
                  class="brand-picker-item"
                  [class.active]="brand.id === workspace.activeBrand()?.id"
                  (click)="selectBrand(brand.id)"
                >
                  {{ brand.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="topbar-right">
          <div
            *ngIf="!workspace.credits().unlimited"
            class="topbar-credits"
            [class.limit-reached]="workspace.credits().limitReached"
            [title]="creditsTooltip()"
          >
            <lucide-icon [img]="icons.credits" size="14"></lucide-icon>
            <span class="credits-label">Runs</span>
            <span class="credits-value">
              {{ workspace.credits().completedRuns }}/{{ workspace.credits().runs }}
            </span>
          </div>

          <button
            *ngIf="notifications.totalBadge() > 0"
            type="button"
            class="topbar-notifications"
            (click)="goToRuns()"
          >
            <lucide-icon [img]="icons.bell" size="16"></lucide-icon>
            <span class="notif-items">
              <span *ngIf="notifications.running() > 0" class="notif-tag notif-running">
                <span class="notif-dot running"></span>
                {{ notifications.running() }} running
              </span>
              <span *ngIf="notifications.unviewedCount() > 0" class="notif-tag notif-completed">
                <span class="notif-dot completed"></span>
                <!--{{ notifications.unviewedCount() }}--> run{{ notifications.unviewedCount() > 1 ? 's' : '' }} completed
              </span>
            </span>
            @if (notifications.unviewedCount() > 0) {
              <span class="notif-badge">{{ notifications.unviewedCount() }}</span>
            }
          </button>

          <div class="topbar-sync" *ngIf="loadingWorkspace">
            <div class="sync-dot"></div>
            <span>Syncing</span>
          </div>
        </div>
      </header>

      <main class="content-shell">
        <section class="panel muted-panel" *ngIf="loadingWorkspace && !workspace.hasWorkspace()" style="margin-bottom: 1rem">
          <div class="loading-skeleton"></div>
          Loading workspace context...
        </section>

        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</ng-container>

<ng-template #publicRoute>
  <router-outlet></router-outlet>
</ng-template>
